"use client"
import { Component } from "@/types/types"
import { BrandMark } from "@/ui/atoms/branding/BrandMark"
import { BrandTagline } from "@/ui/atoms/branding/BrandTagline"
import { TextLink } from "@/ui/atoms/controls/TextLink"
import { SplashCard } from "@/ui/atoms/layout/SplashCard"
import { Stack } from "@/ui/atoms/layout/Stack"
import { BodyText } from "@/ui/atoms/type/BodyText"
import { Title } from "@/ui/atoms/type/Title"
import { SplashLayout } from "@/ui/layouts/SplashLayout"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "serviceStatusView"

export const presets = {}

export interface Props extends Component {}

export function ServiceStatusView({ className, testId = COMPONENT_NAME }: Props) {
  return (
    <SplashLayout className={className} testId={testId}>
      <Stack className={cx("gap-8 w-full max-w-[480px]")}>
        <header>
          <Stack className="gap-2 items-center">
            <TextLink href="/" testId="brandLink">
              <BrandMark className="w-[220px] h-auto" />
            </TextLink>
            <BrandTagline className="text-center" />
          </Stack>
        </header>
        <main>
          <SplashCard className={cx(`w-full max-w-screen-form`, className)}>
            <Stack className="gap-10 md:gap-8">
              <Title size="lg" className="text-center">
                Scheduled maintenance
              </Title>
              <BodyText size="md" className="text-center">
                SANS Foundations is currently down for scheduled maintenance and will return
                shortly. <br /> <br /> Thank you for your patience.
              </BodyText>
            </Stack>
          </SplashCard>
        </main>
      </Stack>
    </SplashLayout>
  )
}
